module.exports = __webpack_public_path__ + "img/Unofficial_flag_of_Guadeloupe.71602cb8.svg";